/**
 * The addresses a token turns into. A calendar's share token and a circle's
 * open at the same path — `/c/<token>` — because to the viewer they are the
 * same kind of thing: a ring, read-only.
 */

export function shareUrl(token: string, origin = location.origin): string {
  return `${origin}/c/${token}`;
}

export function icsUrls(token: string, origin = location.origin): { https: string; webcal: string } {
  const https = `${origin}/cal/${token}.ics`;
  return { https, webcal: https.replace(/^https?:/, 'webcal:') };
}
